import React from "react";
import DownloadAppCard from "../../../Components/UI/DownloadAppCard";
import ThankYouCard from "../../../Components/UI/ThankYouCard";
import { Row, Col, Space, message } from "antd";
import { SectionCardWrapper } from "../../../Components/UI/SectionCardWrapper";
import Footer from "../../Footer";
import { withScroll } from "../../../HOC/withScroll";
import {
  CustomLabel,
  SectionCardHeading,
  Wrapper,
  CustomList,
} from "../../../Common/style";
import DownloadButton from "../../../Components/CustomButton";
import { useIsMobile } from "../../../Hooks";
import { PolicyDetails } from "../CommonData";
// import { sanitizeFileName } from "../../../Utils";
// import  { postApi } from "../../../Services/apiService";
// import { GET_PAYMENT_DOWNLOAD_API } from "../../../Services/endpoints";

const PolicyIssuedPage = () => {
  const isMobile = useIsMobile();
  const {
    policyNum,
    // localPolicyNumber,
    // localApplicationNumber,
    showAccessManipalCigna,
    showEnachSection,
    proposerFirstName,
    // downloadPolicyKit,
    // downloadPaymentAcknowledgement,
    // applicationID,
    renewalYear,
  } = PolicyDetails();

  const onDownload = async (obj) => {
    try {
      // Sanitize fileName to prevent unsafe characters like ../, null byte, etc.
      // const sanitizedFileName = sanitizeFileName(obj?.fileName);
      // Make API call to get the file
      // const resp = await callApi({ ...obj, fileName: sanitizedFileName });
      // Create a download link
      // const link = document.createElement("a");
      // link.setAttribute("download", `${sanitizedFileName}.pdf`);
      // link.href = URL.createObjectURL(new Blob([resp]));
      // // Trigger file download
      // document.body.appendChild(link);
      // link.click();
      // link.remove();
    } catch (err) {
      console.error(err);
      message.error('An error occurred while downloading the file.');
    }
  };

  // const callApi = async (data) => {
  //   try {
  //     const res = await postApi(GET_PAYMENT_DOWNLOAD_API, data, {
  //       responseType: 'blob',
  //       headers: { 'Authorization': "Bearer 07188b28-78d5-45b9-99fa-798a12d29588" },
  //     });
  //     return res;
  //   } catch (err) {
  //     console.error("error-:", err);
  //   }
  // };

  const downloadButton = async (target) => {
    let obj = {
      PolicyNumber: policyNum,
      DocumentClass: "ProposalDocuments",
      DocumentType: "80D",
      RenewalYear: renewalYear,
      ApplicationNumber: '',
      fileName: "Payment Reciept"
    };
    if (target === "form") {
      obj = {
        PolicyNumber: policyNum,
        DocumentClass: "PolicyDocuments",
        DocumentType: "Policy Kit",
        RenewalYear: renewalYear,
        ApplicationNumber: '',
        fileName: "Policy Kit"
      };
    }
    return onDownload(obj);
  };

  return (
    <section>
      <div className="container" style={{ marginTop: "150px" }}>
        <Wrapper>
          <Row justify="space-between" gutter={[32, { xs: 32 }]}>
            {isMobile && (
              <Col xs={24}>
                <ThankYouCard label={"Policy issued"} />
              </Col>
            )}
            <Col lg={18} md={15}>
              <SectionCardWrapper>
                <Row gutter={[0, 24]}>
                  <Col span={24}>
                    <Space direction="vertical">
                      <SectionCardHeading>
                        Hi {proposerFirstName}!{" "}
                        <label
                          style={{
                            fontSize: "14px",
                            fontWeight: "normal",
                            display: "inline",
                          }}
                        >
                          your Payment was successful!
                        </label>
                      </SectionCardHeading>
                    </Space>
                  </Col>
                  <Col span={24}>
                    <Row gutter={[0, 24]}>
                      {/* {downloadPolicyKit && ( */}
                       { false && <Col lg={10} xs={24}>
                          <DownloadButton
                            label="Download Policy Kit"
                            onClick={() => downloadButton("form")}
                          />
                        </Col>}
                      {/* {downloadPaymentAcknowledgement && ( */}
                        {false && <Col
                          lg={10}
                          xs={24}
                          style={{ textAlign: "left" }}
                        >
                          <DownloadButton
                            label="Download Payment Receipt"
                            onClick={() => downloadButton("payment")}
                          />
                        </Col>}
                    </Row>
                  </Col>
                  <Col span={24}>
                    <CustomLabel font_size="14" font_weight="normal">
                      Thank you for choosing ManipalCigna as your preferred
                      Health Insurance partner.<br />
                      {/* We are pleased to acknowledge your payment.<br />
                      Your policy is issued. */}
                    </CustomLabel>
                  </Col>
                  <Col span={24}>
                    {/* <CustomLabel font_size="14" font_weight="normal">
                      In order to process your proposal, we would require the
                      following within 7 working days of the date of this
                      intimation.
                    </CustomLabel> */}
                  </Col>
                </Row>
              </SectionCardWrapper>
              {/* ------------------footer------------------------------------------------ */}
              {showEnachSection && (
                <SectionCardWrapper>
                  <Row gutter={[0, 24]}>
                    <Col span={24}>
                      <Row>
                        <Col lg={18} md={20} xs={24}>
                          <h4>
                            <strong> Registration for eNACH</strong>
                          </h4>
                          <div>&nbsp;</div>
                          <span>
                            <input type={"checkbox"} />
                            <h4 style={{ display: "inline" }}>
                              <strong> &nbsp; Register eNACH</strong>
                            </h4>
                            <CustomLabel font_size="12" font_weight="normal">
                              {" "}
                              &nbsp; &nbsp;&nbsp; &nbsp; I hereby confirm to
                              have read, understood and agree to all{" "}
                              <strong>T&Cs & Disclaimer.</strong>{" "}
                            </CustomLabel>
                          </span>
                          <div> &nbsp; &nbsp; &nbsp;</div>
                          <span></span>
                          <h4>
                            <strong>What is eNACH?</strong>
                          </h4>
                          <CustomLabel font_size="12" font_weight="normal">
                            Registering for eNACH will enable Auto renewal of
                            your policy every year.
                          </CustomLabel>
                          <div> &nbsp; &nbsp;</div>
                          <h4>
                            <strong>Benefits of opting for eNACH:</strong>
                          </h4>
                          <ul>
                            <CustomList font_size="12" font_weight="normal">
                              You'll save % on your renewal amount next year
                            </CustomList>
                            <CustomList font_size="12" font_weight="normal">
                              Don't worry of policy getting lapsed - You are
                              always covered
                            </CustomList>
                          </ul>
                        </Col>
                        <Col lg={6} md={4} xs={24}>
                          <Footer
                            onNext={() => console.log("test")}
                            nextLabel="Next"
                            hideBack={true}
                            colorType="primary"
                            mobileNextPos="left"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </SectionCardWrapper>
              )}
            </Col>
            <Col lg={6} md={9}>
              <Row gutter={[0, { lg: 32, md: 32, xs: 0 }]}>
                {!isMobile && (
                  <Col span={24}>
                    <ThankYouCard label={"Policy Issued"} />
                  </Col>
                )}
                {showAccessManipalCigna && (
                  <Col span={24}>
                    <DownloadAppCard />
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Wrapper>
      </div>
    </section>
  );
};

export default withScroll(PolicyIssuedPage);
